import * as angular from "angular";
import { Group } from "../../models/group.model";
import { Team } from "../../models/team.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { TeamDataProvider } from "../../data-provider/team.dp";

let TeamInfoComponent = {
    selector: "vcTeamInfo",
    templateUrl: "/angular/components/team/team-info.component.html",
    bindings: {},
    controller: class TeamInfoController {
        public team: Team;
        public tid: string | number;
        public groups: Group[] = [];
        public surveys: any[] = [];
        public points: any[] = [];

        private readonly $scope: any;
        private $location: any;
        private readonly toast: ToastUtils;
        private readonly dialog: DialogUtils;
        private dataProvider: TeamDataProvider;

        constructor(
            $scope: any,
            $location: any,
            $routeParams: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            TeamDataProvider: TeamDataProvider
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.dataProvider = TeamDataProvider;

            this.tid = $routeParams.tid;
            this.dataProvider
                .getTeam(this.tid)
                .then((team: Team) => (this.team = team));

            this.dataProvider
                .getTeamGroups(this.tid)
                .then((teamGroups: Group[]) => (this.groups = teamGroups));
            this.dataProvider
                .getTeamSurveys(this.tid)
                .then((teamSurveys: any[]) => (this.surveys = teamSurveys));
            this.dataProvider
                .getTeamTalkingPoints(this.tid)
                .then(
                    (teamTalkingPoints: any[]) =>
                        (this.points = teamTalkingPoints)
                );
        }

        redirectToGroup(group: Group): void {
            this.$location.url(
                "./#/people?filter=%7B%7D&selected_group=" +
                    group.gid +
                    "&tab=groups"
            );
        }

        deleteTeam(team: Team, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: "Delete Team?",
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.dataProvider.deleteTeam(team).then(
                        () => {
                            this.toast.success("Team deleted");
                            this.dialog.cancel();
                        },
                        () => this.toast.error()
                    );
                });
        }

        openEditTeamDialog(team: Team, ev: any): void {
            this.dialog
                .show({
                    component: "vc-team-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large-plus",
                    ariaLabel: "Create Team",
                    locals: {
                        selectedTeam: team,
                        hideUsers: false,
                    },
                })
                .then((newTeam: Team) => {
                    if (team) angular.extend(team, newTeam);
                });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular.module("team").component(TeamInfoComponent.selector, TeamInfoComponent);
